export function modelsFromObject(structure = {}) {
  return Object.keys(structure).map(function(id) {
    return {
      _id: id,
      ...structure[id]
    };
  });
}



// WEBPACK FOOTER //
// ./src/helpers/models-from-object.js